"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInfinityScrollPagination = void 0;
var useInfinityScrollPagination_1 = require("./useInfinityScrollPagination");
Object.defineProperty(exports, "useInfinityScrollPagination", { enumerable: true, get: function () { return __importDefault(useInfinityScrollPagination_1).default; } });
